import { render, staticRenderFns } from "./leadsPerFormAndTime.vue?vue&type=template&id=71b5f564"
import script from "./leadsPerFormAndTime.vue?vue&type=script&lang=js"
export * from "./leadsPerFormAndTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports